import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import AppProfileIcon from 'src/components/BeaconV2Components/Header/AppProfileIcon';
import { useAppSelector } from 'src/utils/Hooks';
import { useFormContext } from 'react-hook-form';

export const CreatedBySection: React.FC = () => {
  const form = useFormContext();
  const currentUser = useAppSelector((state) => state.user);
  const { team } = currentUser;

  // Get variant and createdBy from form context
  const variant = form.watch('variant');
  const createdBy = form.watch('createdBy');

  // Determine userId and user data based on variant
  let userId: string | undefined;
  let firstName: string | undefined;
  let lastName: string | undefined;

  if (variant === 'add') {
    // 'add' mode - show current logged-in user
    userId = currentUser.session.userId;
    firstName = currentUser.config.profile.firstName;
    lastName = currentUser.config.profile.lastName;
  } else if (variant === 'edit' && createdBy) {
    // 'edit' mode - show profile creator from createdBy field
    const creator = team.find((u) => u.id === createdBy);
    userId = createdBy;
    firstName = creator?.firstName;
    lastName = creator?.lastName;
  } else {
    return null;
  }

  // Render common structure
  return (
    <Flex flexDirection="column" gap={8}>
      <Text variant="body2" fontWeight={500}>
        Created By
      </Text>
      <Flex gap={8} alignItems="center">
        <div
          style={{
            height: '30px',
            width: '30px',
            overflow: 'hidden',
            borderRadius: '50%'
          }}
        >
          <AppProfileIcon
            userId={userId}
            size={30}
            fontSize="12px"
            initials={`${firstName?.[0] || ''}${lastName?.[0] || ''}`}
          />
        </div>
        <Flex flexDirection="column" gap={2}>
          <Text variant="body2" sx={{ lineHeight: '30px' }}>
            {firstName} {lastName}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
